






export default {
  name: 'List',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/components/list/List.vue